import { REGION_LIST } from '@ms/setting'
import { REGION } from '@ms/config/app'

/**
 * 检测当前访问国家和 ip 国家是否不一致
 * @param {String} ipRegion  ip 国家
 * @returns 不一致返回 true, 如果有切换过，则直接重定向
 */
export function checkRegion(ipRegion = '') {
  // ip 与当前版本不匹配, 并且用户没有切换过 region, 不弹窗
  let userRegion = localStorage.getItem('USER_REGION')
  if (REGION_LIST.every((x) => x.country !== userRegion)) {
    userRegion = ''
    localStorage.removeItem('USER_REGION')
  }

  if (userRegion) {
    // 有切换过, 并且和当前站点不一致，直接重定向
    if (REGION !== userRegion) {
      // 开发和测试环境不自动重定向
      if (process.env.NODE_ENV !== 'development' && !/test/.test(location.host)) {
        const resolveUrl = (url) => {
          const reg = new RegExp(`([-/])${REGION}`, 'g')
          return url.replace(reg, `$1${userRegion}`)
        }
        location.href = resolveUrl(location.href)
      }
    }
  } else {
    // 当前国家不匹配，应该弹出切换国家弹窗
    if (ipRegion && ipRegion !== REGION) {
      return true
    }
  }
}

function forEachKey(callback) {
  const keys = []
  for (let i = 0; i < localStorage.length; i++) {
    keys.push(localStorage.key(i))
  }
  keys.forEach((key) => {
    callback(key)
  })
}

/**
 * 切换国家
 * @param {String} region   目标国家
 * @param {String} source         切换功能所在功能模块
 * @param {Boolean} auto          是否是自动切换
 */
export function switchRegion({ region = '', source = '', auto = false, redirectUrl = '' }) {
  if (region !== REGION) {
    // 记录切换来源
    if (auto) {
      source = 'IPmatched'
    }
    window.mstrace(`SwitchCountry_${source}`, 'SwitchCountry')
    // 清除缓存
    forEachKey((key) => {
      if (!['visited', 'RHTJ5V'].includes(key)) {
        localStorage.removeItem(key)
      }
    })
    sessionStorage.clear()
    localStorage.setItem('USER_REGION', region)
    // test1-ng 是测试地址，也需要替换
    const targetUrl = redirectUrl ? location.origin + redirectUrl : location.href
    const link = targetUrl.replace(`-${REGION}.`, `-${region}.`).replace(`/${REGION}`, `/${region}`)
    if (process.env.NODE_ENV === 'development') {
      return location.reload()
    }
    location.href = link
  } else {
    localStorage.setItem('USER_REGION', region)
  }
}
